import React, { useCallback ,useState,useEffect} from 'react';
import { mapModifiers } from 'libs/component';
import Default from 'components/templates/default';
import { Heading } from 'components/atoms/heading';
import { Text } from 'components/atoms/text';
import { Section } from 'components/molecules/section';
import { FloorSelectorFull } from 'components/molecules/floor-selector-full';
import { FLOOR_LIST } from 'libs/constants';
import { useTranslation } from 'react-i18next';

const heroImage = '/images/hero-banners/venue-information.jpg';
const heroImageSp = '/images/hero-banners/venue-information-sp.jpg';

export interface VenueProps {
  currentTab?: number;
  children?: React.ReactNode;
  onFloorActionClick?: (floor: string) => void;
}

export const Venue: React.FC<VenueProps> = ({ onFloorActionClick ,currentTab: defaultCurrentTab = 0}) => {
  const { t, i18n } = useTranslation();
  const floorList = FLOOR_LIST;


  const [currentTab, setCurrentTab] = useState<number>(defaultCurrentTab);

  useEffect(() => {
    setCurrentTab(defaultCurrentTab);
  }, [setCurrentTab, defaultCurrentTab, currentTab]);
  const handleFloorActionClick = useCallback(
    (floor: string) => {
      if (onFloorActionClick) {
        onFloorActionClick(floor);
      }
    },
    [onFloorActionClick]
  );
  return (
    <div className={mapModifiers('t-venue', i18n.language)}>
      <Default heroImage={heroImage} heroImageSp={heroImageSp}>
        <Heading>场馆信息</Heading>
        <div className="t-venue__description">
          <Text>
            <span
              dangerouslySetInnerHTML={{
                __html: t('venue.description'),
              }}
            />
          </Text>
          <br />
          <Text>{t('venue.scroll-text')}</Text>
        </div>

        <Section className="t-venue__floor-selectors">
          <FloorSelectorFull floors={floorList} onFloorActionClick={handleFloorActionClick} />
        </Section>

          {/* <div className={mapModifiers('t-venue__description')}>
            <div className="event "><a className="promotion" href='https://qsncc.com/en/visit/food-and-retail/' target=" _blank ">活动促销</a></div>

            <Text>
              <span
                dangerouslySetInnerHTML={{
                  __html: t('venue.promotion'),
                }}
              />
            </Text>
          </div> */}
    
      </Default>
    </div>
  );
};
